import { DateTime, Expose, Transform } from '@nts/std';

export class UsageReportFiltersDto {

    @Expose()
    public base64CsvContent: string;
}
